import { render, staticRenderFns } from "./list-warehouse.vue?vue&type=template&id=51027a93"
import script from "./list-warehouse.vue?vue&type=script&lang=js"
export * from "./list-warehouse.vue?vue&type=script&lang=js"
import style0 from "./list-warehouse.vue?vue&type=style&index=0&id=51027a93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports